import { injectedResourceTreeSlice } from "./reducer";
import { createServiceBuilder } from "./lib";
const { actions, selectors } = injectedResourceTreeSlice;
export const ResourceTreeServiceBuilder = createServiceBuilder({
    name: 'ResourceTreeService',
    api: ({ ProjectService }) => ({
        actions,
        selectors,
        getSelectedResource: () => (dispatch, getState) => {
            const selectedID = selectors.getSelectedResourceID(getState());
            if (!selectedID)
                return;
            return ProjectService.getResourceByID(getState(), selectedID);
        },
    }),
});
//# sourceMappingURL=ResourceTreeService.js.map